import styled from "styled-components";

const ButtonStyled = styled.button<{
  backgroundColor?: string;
  hoverColor?: string;
  border?: string;
  size?: string;
  width?: string;
}>`
  border: none;
  margin: none;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.color || "#FFF"};
  border: ${(props) => props.border || "none"};
  ${(props) =>
    props.size === "SM"
      ? `
  height: 40px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  padding: 8px 32px;
  gap: 8px;
  `
      : `
  height: 56px !important;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.25px;
  padding: 14px 40px;
  gap: 8px;
  `}
  width: ${(props) => props.width || "auto"};

  border-radius: 50px;

  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.hoverColor || props.backgroundColor};
    transition: 0.5s;
  }
`;

export default ButtonStyled;
